import React from 'react';

export function useErrorHandler(
  givenError?: unknown,
): (error: unknown) => void {
  const [error, setError] = React.useState<unknown>(null);
  if (givenError != null) throw givenError;
  if (error != null) throw error;
  return setError;
}

export default useErrorHandler;
